export default __webpack_public_path__ + "568b299a507ec87b367fdb7c46e96365.svg";